import { updateLinksAttributes } from '../utils/handleAttributes';

export default function affiliatesLogos() {
  const widgetName = 'affiliatesLogos';
  const widgetOpts = affiliatesLogosOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 10,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createAffiliatesLogos(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });

  function createAffiliatesLogos(widgetData, $widget) {
    $widget.find('.card-content').remove();
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $sponsor = $(this);
      updateLinksAttributes(URL, Title, $sponsor);
    });
  }
}
